import React, { useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

const Counter = ({ start, end, interval = 50 }) => {
    const [count, setCount] = useState(start);
    const { ref, inView } = useInView({
        triggerOnce: true,
        threshold: 0.1,
    });

    useEffect(() => {
        if (inView) {
            let current = start;
            const intervalId = setInterval(() => {
                console.log(`Counter from ${current} to ${end} started`);

                if (current < end) {
                    setCount(prevCount => prevCount + 1);
                    current += 1;
                } else {
                    clearInterval(intervalId);
                }
            }, interval);

            return () => clearInterval(intervalId);
        }
    }, [inView, start, end, interval]);

    return (
        <span className="count" ref={ref}>{count}</span>
    );
};

export default Counter;
